import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useAppContext } from "../../../contexts/AppContext";
import LocationModal from "../LocationModal";

const RescheduleSession = ({
  rescheduleData,
  cities,
  handleSelectedSessionToParent,
}) => {
  const { currentUser } = useAppContext();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [isAvailableCountLoading, setAvailableCountLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [expandedRegions, setExpandedRegions] = useState({});
  useEffect(() => {
    if (rescheduleData) {
      setScheduleData(
        rescheduleData.map((item) => {
          const firstDate = item.dates?.[0];
            const rawDate = firstDate ? new Date(firstDate.day + "T00:00:00") : null;

          // Format date: Wed, May 03, 2023
          const formattedDate = rawDate
            ? rawDate.toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "2-digit",
                year: "numeric",
              })
            : null;

          // Format times: 08:30 AM, 12:00 PM
          const formatTime = (day, time) =>
            time
              ? new Date(`${day}T${time}`).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
              : null;

          return {
            id: item.id_session,
            date: formattedDate,
            rawDate,
            startTime: formatTime(firstDate?.day, firstDate?.time_begin),
            endTime: formatTime(firstDate?.day, firstDate?.time_end),
            city: item.name?.split(" - ")[0],
            locationInfo: {
              name: firstDate?.location_name,
              address: firstDate?.location_address,
            },
            seats: item.max_enroll,
          };
        })
      );
    }
  }, [rescheduleData]);
   const toggleRegion = (region) => {
    setExpandedRegions((prev) => ({
      ...prev,
      [region]: !prev[region],
    }));
  };
  const groupedCities = cities.reduce((acc, city) => {
    if (!acc[city.regionname]) acc[city.regionname] = [];
    acc[city.regionname].push(city?.name);
    return acc;
  }, {});

  const handleCityToggle = (city) => {
    setSelectedCities((prev) =>
      prev.includes(city) ? prev.filter((c) => c !== city) : [...prev, city]
    );
  };

  const filteredSchedule = useMemo(() => {
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    if (to) {
      to.setHours(23, 59, 59, 999);
    }

    return scheduleData
      .filter((entry) => {
        if (from && entry.rawDate < from) return false;
        if (to && entry.rawDate > to) return false;
        if (selectedCities.length > 0 && !selectedCities.includes(entry.city))
          return false;
        return true;
      })
      .sort((a, b) => b.rawDate - a.rawDate);
  }, [scheduleData, fromDate, toDate, selectedCities]);

  return (
    <div className="schedule-page">
      <div className="filters-panel">
        <div className="date-filter">
          <div className="date-filter-heading">Date Filters</div>
          <div className="date-group">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="date-group">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              min={fromDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>

        <div className="location-filter-heading">Location Filters</div>

              {Object.entries(groupedCities).sort(([regionA], [regionB]) => regionA.localeCompare(regionB)
              ).map(([region, cityNames]) => (
           <div key={region} className="filter-group">
            <div
              className="filter-heading"
              style={{
                fontSize: "16px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>{region}</div>

              <div
                style={{ cursor: "pointer" }}
                onClick={() => toggleRegion(region)}
              >
                {expandedRegions[region] ? "-" : "+"}
              </div>
            </div>

            {expandedRegions[region] &&
              cityNames.map((city, index) => (
                <label key={city} className="filter-option">
                  <input
                    id={index}
                    type="checkbox"
                    checked={selectedCities.includes(city)}
                    onChange={() => handleCityToggle(city)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleCityToggle(city);
                      }
                    }}
                  />
                  <span className="cityList">{city}</span>
                </label>
              ))}
          </div>
        ))}
      </div>

      <div className="schedule-bt30-table" style={{ minHeight: "75vh" }}>
        {filteredSchedule?.length > 0 ? (
          <>
            <div className="bt30-table-header">
              <div>Select</div>
              <div style={{ marginLeft: "10px" }}>Class Date</div>
              <div style={{ marginLeft: "2px" }}>Location</div>
              {currentUser.isPowerUser && <div>Available Seats</div>}
            </div>

            {filteredSchedule.map((entry, index) => (
              <div key={index} className="bt30-table-row">
                <div className="table_radio_button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        
                        e.preventDefault();
                        handleSelectedSessionToParent(entry, true);
                        document.getElementById(`radio-${index}`).checked = true; // ensure visual selection
                      }
                    }}>
                  <input
                    type="radio"
                    id={`radio-${index}`}
                    style={{ cursor: "pointer" }}
                    name="scheduleSelect"
                    value={entry.id}
                    onChange={(e) => {
                      handleSelectedSessionToParent(entry, e.target.checked);
                    }}
                  />
                </div>
                <div className="class-date-time">
                  <div className="class-date">{entry.date}</div>
                  <div>
                    {entry.startTime} - {entry.endTime}
                  </div>
                </div>
                <div className="bt30-table-location">
                  <div style={{ fontWeight: "bold" }}>{entry.city}</div>
                  <div
                    className="locationLinkTextBt30"
                    tabIndex={0}
                      onKeyDown={(e) => {
                        // support Enter/Space activation
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setSelectedLocation(entry.locationInfo);
                          setShowLocationModal(true);
                        }
                      }}
                    onClick={() => {
                      setSelectedLocation(entry.locationInfo);
                      setShowLocationModal(true);
                    }}
                  >
                    {entry.locationInfo?.name}
                  </div>
                </div>
                {!isAvailableCountLoading ? (
                  <div
                    style={{
                      color: entry.seats > 0 ? "black" : "#be0606",
                      fontWeight: entry.seats > 0 ? "bold" : "normal",
                    }}
                  >
                    {entry.seats}
                  </div>
                ) : (
                  <Spinner
                    className="me-1"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                {/* )} */}
              </div>
            ))}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "200px",
            }}
          >
            No record(s) found.
          </div>
        )}
      </div>
      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        location={selectedLocation}
      />
    </div>
  );
};

export default RescheduleSession;
